"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldCodeParserTime = void 0;
var tslib_1 = require("tslib");
var names_1 = require("../names");
var field_code_parser_date_1 = require("./field-code-parser-date");
var FieldCodeParserTime = (function (_super) {
    tslib_1.__extends(FieldCodeParserTime, _super);
    function FieldCodeParserTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FieldCodeParserTime.prototype, "name", {
        get: function () { return names_1.FieldName.Time; },
        enumerable: false,
        configurable: true
    });
    FieldCodeParserTime.prototype.getDefaultFormat = function () {
        return this.modelManager.richOptions.fields.defaultTimeFormat;
    };
    return FieldCodeParserTime;
}(field_code_parser_date_1.FieldCodeParserDate));
exports.FieldCodeParserTime = FieldCodeParserTime;
